import styled from "@emotion/styled";

import { fontMerriweather, fontRobotoCondensed, theme } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";

export const Container = styled.div``;

export const StyledEntityLink = styled(EntityLink)`
  display: flex;
  gap: 12px;
  align-items: flex-start;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 8px;

  min-inline-size: 0;
`;

export const Label = styled.div`
  color: #333333;
  /* The podcast label is Roboto Condensed Regular in the Figma (6992:295567),
     unlike the Medium video/infographic labels. */
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
  text-transform: uppercase;
`;

export const Headline = styled.div`
  color: #000000;
  font-weight: 600;
  font-size: 15px;
  font-family: ${fontMerriweather};
  line-height: 140%;

  ${theme.breakpoints.up("tablet")} {
    font-size: 14px;
  }
`;

export const StyledFigure = styled.figure`
  flex: none;

  inline-size: 96px;
  block-size: 96px;

  img {
    inline-size: 100%;
    block-size: 100%;

    object-fit: cover;
  }
`;
